{
  "labels": {
    "textSingleLine": "文本 - 单行",
    "textMultipleLines": "文本 - 多行",
    "date": "日期",
    "trueFalse": "是/否",
    "singleDocument": "单个文档",
    "multiDocument": "多个文档",
    "number": "数字",
    "eMail": "电子邮件",
    "phone": "电话",
    "dropDownSingleSelectList": "下拉单选列表",
    "dropDownMultiSelectList": "下拉多选列表",
    "comboBox": "组合框",
    "timestamp": "时间戳",
    "featureLink": "功能链接"
  },
  "descriptions": {
    "openTextFieldSingleLine": "开放式文本字段，单行",
    "openTextFieldMultipleLines": "开放式文本字段，多行",
    "formatMmDdYyyy": "格式 MM/DD/YYYY",
    "toggleButton": "切换按钮",
    "singleFileUploadField": "单文件上传字段",
    "multipleFileUploadField": "多文件上传字段",
    "numericInputField": "数字输入字段",
    "emailAddressInputField": "电子邮件地址输入字段",
    "format1XxxXxxXxxx": "格式 +1(XXX) XXX-XXXX",
    "selectOneOptionFromAList": "从列表中选择一个选项",
    "selectMultipleOptionsFromAList": "从列表中选择多个选项",
    "singleOptionDropDownListOpenTextField": "单选下拉列表 + 开放式文本字段",
    "dateAndTimeFields": "日期和时间字段",
    "linkToTheFormFeatures": "链接到表单功能"
  }
}
